import { formatCurrency } from '../formatters/money';

/** salePrice / weightGrams; null when weight is missing or zero. */
export function computeSalePricePerGram(
  salePrice: number | null | undefined,
  weightGrams: number | null | undefined,
): number | null {
  const price = Number(salePrice);
  const weight = Number(weightGrams);
  if (!Number.isFinite(price) || !Number.isFinite(weight) || weight <= 0) {
    return null;
  }
  return price / weight;
}

export function formatSalePricePerGram(
  salePrice: number | null | undefined,
  weightGrams: number | null | undefined,
): string {
  const value = computeSalePricePerGram(salePrice, weightGrams);
  if (value == null) {
    return 'N/A';
  }
  return `${formatCurrency(value)}/g`;
}
